import createReducer from '../utils/createReducer';
import actions from '../actions/confirmBrand';

const initialState = {};

const actionHandlers = {
    [actions.CONFIRM_BRAND](state, { payload }) {
        return {
            ...state,
            primarySite: payload.primarySite
        };
    },
    [actions.DISMISS_ALERT_BOX](state, { }) {
        return {
            ...state,
            serviceError: ''
        };
    },
    [actions.CONFIRM_BRAND_SERVICE_ERROR](state, { payload }) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    }
};

export default createReducer(actionHandlers, initialState);
